export default __webpack_public_path__ + "static/media/youtubeFooter.f5443e1c.svg";